import type { ReactNode } from 'react';
import { UptimeDropdown } from '../UptimeDropdown';
import './styles.scss';

export interface IUptimeSelectOption<T extends string | number> {
    value: T;
    label: ReactNode;
}

export interface IUptimeSelectProps<T extends string | number> {
    value: T;
    options: IUptimeSelectOption<T>[];
    onChange: (value: T) => void;
    label?: ReactNode;
    align?: 'left' | 'right';
    disabled?: boolean;
    className?: string;
    triggerClassName?: string;
    menuClassName?: string;
}

export const UptimeSelect = <T extends string | number>({
    value,
    options,
    onChange,
    label,
    align,
    disabled,
    className,
    triggerClassName,
    menuClassName,
}: IUptimeSelectProps<T>) => {
    const selected = options.find(option => option.value === value);

    return (
        <UptimeDropdown
            className={className}
            triggerClassName={triggerClassName}
            menuClassName={`upt-select__menu${menuClassName ? ` ${menuClassName}` : ''}`}
            align={align}
            disabled={disabled}
            label={
                <>
                    {label && <span className='upt-select__prefix'>{label}</span>}
                    <span className='upt-select__value'>{selected?.label}</span>
                </>
            }
        >
            {close =>
                options.map(option => {
                    const isSelected = option.value === value;
                    return (
                        <button
                            type='button'
                            key={String(option.value)}
                            className={`upt-select__option${isSelected ? ' upt-select__option--selected' : ''}`}
                            aria-pressed={isSelected}
                            onClick={() => {
                                onChange(option.value);
                                close();
                            }}
                        >
                            <span className='upt-select__check' aria-hidden='true'>
                                {isSelected ? '✓' : ''}
                            </span>
                            {option.label}
                        </button>
                    );
                })
            }
        </UptimeDropdown>
    );
};

export default UptimeSelect;
